<div class="avatar-profile-container">
  @if (!imgProfile) {
    <div class="fullname-initials" [ngClass]="config?.avatarSize">
      <span>{{ fullName | initials | uppercase}}</span>
    </div>
  }
  @if (imgProfile) {
    <img class="user-profile-img" [src]="imgProfile" >
  }
  <div class="profile-content">
    <h4>{{ fullName }}</h4>
    @if (email) {
      <h5> {{ email }}</h5>
    }
  </div>
</div>
